import { RouterClient } from "../../../../clients/routerClient";
import { Logger } from "../../../../clients/logger";
import { Launcher } from "../Launcher/launcher";

export class WindowCreateEntry {
	launcher: Launcher;

	moduleReady = false;

	constructor(launcher: Launcher) {
		this.launcher = launcher;
		this.bindAllFunctions();
		this.definePubicInterface_Window();
	}

	setReady() {
		this.moduleReady = true;
	}

	windowServiceChannelName(channelTopic) {
		return `WindowService-Request-${channelTopic}`;
	}

	bindAllFunctions() {
		const self = this;
		for (const name of Object.getOwnPropertyNames(Object.getPrototypeOf(self))) {
			if (self[name] instanceof Function) {
				self[name] = self[name].bind(self); // only bind function properties
			}
		}
	}

	definePubicInterface_Window() {
		// entry points for public window functions

		// NOTE: createWindow is now internal to launcher (i.e. spawn invokes createWindow directly)
		// NOTE: after more window-service cleanup this file will likely be rolled into another, but for now keeping as is to reduce confusion as we evolve

		RouterClient.addResponder(this.windowServiceChannelName("getWindowIdentifier"), this.getWindowIdentifier);
	}

	// probably only a temporary routine -- currently supports public wrapper
	async getWindowIdentifier(queryError, queryMessage) {
		this.moduleReady || Logger.system.error("windowService window creation invoked before ready", queryMessage);
		Logger.system.debug(
			`WindowService-Request-getWindowIdentifier for ${queryMessage.data.windowName}`,
			queryMessage.data
		);
		this.launcher.createSplinterAndInject.getWindowIdentifier(queryMessage.data, (err, data) => {
			queryMessage.sendQueryResponse(err, data);
		});
	}
}
